import axios from "axios";
import { baseAddress } from "../../../tools/baseAddress";
import { ENDPOINTS } from "../../../tools/endpoints";
import FileSaver from "file-saver";

export const getAnalytics = (startTime, endTime) => {
  const addressAnalytics = baseAddress + ENDPOINTS.ANALYTICS_DATA;
  
  return axios
    .post(addressAnalytics, {
      start: startTime,
      end: endTime,
      token: localStorage.getItem("token")
    })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      if (err.response === undefined || err.status === 500 || "500" in err.response)
        return { "data": "Internal server error! Please try again." };
      return err.response
    });
};

export const exportAnalytics = (startTime, endTime) => {
  const addressExport = baseAddress + ENDPOINTS.ANALYTICS_SIMULATION_DATA;

  return axios
    .post(
      addressExport,
      {
        start: startTime,
        end: endTime,
        token: localStorage.getItem("token"),
      }
    )
    .then((response) => {
      const data = response.data;
      
      // Download simulation CSV
      const simulationBlob = new Blob([data.simulation], { type: "text/csv" });
      FileSaver.saveAs(simulationBlob, `simulation.csv`);
      
      // Download config CSV
      const configBlob = new Blob([data.config], { type: "text/csv" });
      FileSaver.saveAs(configBlob, `config.csv`);
      
      return response;
    })
    .catch((err) => {
      console.error('Export error:', err);
      if (err.response === undefined || err.status === 500 || "500" in err.response)
        return { "data": "Internal server error! Please try again." };
      return err.response;
    });
};